import "pwa-mmt-ui-header/ssr/header.css";
import React, { useContext, useEffect } from "react";
import PreloadImages from "./PreloadImages";

import {
  DomesticTrip,
  SecureTravOffer,
  TravellingTo,
} from "@insurance/landing-ui/components";
import { ExperimentTrackingString, useBreakpointV2 } from "@tm/ui-widgets";
import {
  DesktopLayout,
  FlexComp,
  FormattedText,
  ImageComponent,
  SpanTag,
} from "@tm/ui-widgets/components";
import { theme } from "@tm/utility/global";

import InsuranceBottomComp from "./InsuranceBottomComp";

import { getAnalytics } from "@tm/insurance/analytics";
import { navigationActions } from "@tm/insurance/navigation";
import { getCookieByName } from "@tm/insurance/utils";
import { usePartnerContext } from "@tm/ui-widgets/hooks";
import InsuranceLandingShimmer from "./InsuranceLandingShimmer";
import { LandingPageProps } from "./types";

import { LandingPageRightWrapper } from "./InsuranceLanding.style";

const analytics = getAnalytics();

const InsuranceLanding = ({ data, setActiveModal }: LandingPageProps) => {
  const context = usePartnerContext();
  const experiment = useContext(ExperimentTrackingString) || "";

  if (!data) return <InsuranceLandingShimmer />;

  const {
    title,
    claimSettlementText,
    secureTravData,
    travellingTo,
    calendarDatesLimit,
    upcomingTrip,
    upcomingTripsV2,
    errorFields,
    footer,
    travelSearchBanner,
    nextPageRoute,
    analytics: pageAnalytics,
  } = data || {};

  const device = useBreakpointV2();

  useEffect(() => {
    if (data) {
      if (pageAnalytics?.pageLoad) {
        analytics?.trackRawPageLoadEvent(pageAnalytics.pageLoad);
      } else {
        analytics?.trackPageLoadEvent({
          pageName: "LANDING",
          experiment,
        });
      }
    }
  }, [data]);

  const goToMyOrders = () => {
    analytics?.trackLandingEvents({
      actionType: "my_orders_clicked",
    });

    const authCookie =
      getCookieByName("mmt-auth") || getCookieByName("OAUTH-GOIBIBO");

    if (authCookie) {
      navigationActions.navigateToOrderListing();
    } else {
      setActiveModal?.("LOGIN");
    }
  };

  return (
    <>
      <PreloadImages data={data} />
      <DesktopLayout
        landingPageProp
        title={title}
        height={device == "lg" ? "720px" : ""}
        rightSectionHeight="unset"
        leftSectionHeight
        landingMargin
        goToMyOrders={goToMyOrders}
        leftComp={
          <React.Fragment>
            <FlexComp
              margin={device == "sm" ? "0 0 0px" : context ? "-30px 0 0" : ""}
              alignItems="center"
              gap="6px"
            >
              <ImageComponent
                width="12px"
                height="16px"
                src={claimSettlementText?.icon}
                loading="eager"
              />
              <SpanTag fontSize="xs" fontWeight="bold" color={theme.blackText}>
                <FormattedText value={claimSettlementText?.title} />
              </SpanTag>
            </FlexComp>
            {device == "lg" ? <SecureTravOffer data={secureTravData} /> : ""}
          </React.Fragment>
        }
        rightComp={
          <LandingPageRightWrapper>
            {upcomingTripsV2 && (
              <DomesticTrip
                title={upcomingTripsV2?.title}
                trips={upcomingTripsV2?.trips}
              ></DomesticTrip>
            )}
            <TravellingTo
              travelSearchBanner={travelSearchBanner}
              travellingToSection={travellingTo}
              upcomingTrip={upcomingTrip}
              calendarDatesLimit={calendarDatesLimit}
              nextPageRoute={nextPageRoute}
              errorFields={errorFields}
              countryCodes={data.countryCode}
              setLoginModal={setActiveModal}
            />

            {device != "lg" && <SecureTravOffer data={secureTravData} />}
          </LandingPageRightWrapper>
        }
        bottomComp={
          <InsuranceBottomComp bottomCompData={data} footerInfo={footer} />
        }
      ></DesktopLayout>
    </>
  );
};

export default InsuranceLanding;
